<template lang="pug">
  div.wrap-trainer-home.f.fh
    div
      div.mb12
        v-avatar(size="160px").mb12
          img(:src="trainer.iconURL")
        div.f.fc
          span {{trainer.name}}
      div.f.fc
        span(@click="logout").logout ログアウト
</template>

<style lang="scss" scoped>
.wrap-trainer-home {
  width: 100%;
  min-height: 100vh;
  .logout {
    cursor: pointer;
    color: #ff5252;
    font-size: 12px;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')

export default {
  components: {
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  props: {
    trainer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: true
    }
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    onLoggedIn () {
      
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    logout () {
      this.signOut()
      this.$router.push('/sign-in')
    }
  }
}
</script>
